<template>
  <div>
    <v-app-bar app>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        v-if="connected"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <dark-mode-switch></dark-mode-switch>
      <file-upload-icon v-if="connected"></file-upload-icon>
      <bell-icon v-if="connected"></bell-icon>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" v-if="connected" width="300">
      <v-list dense class="pt-2" subheader nav>
        <logo></logo>
        <v-divider></v-divider>

        <!-- Avoid v-if with v-for https://v3.vuejs.org/style-guide/#avoid-v-if-with-v-for-essential -->
        <template v-for="(entry, i) in menuEntries">
          <v-list-item
            :key="i"
            v-if="!entry.submenu"
            @click="pushRoute(entry)"
            :class="{ 'v-list-item--active': $route.name === entry.route.name }"
          >
            <v-list-item-icon>
              <v-badge
                color="error"
                :value="entry.title === 'Chat' && $store.getters.unreadMessages"
              >
                <template #badge>
                  <span>{{ $store.getters.unreadMessages }}</span>
                </template>
                <v-icon>{{ entry.icon }}</v-icon>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ entry.title }}
                <v-icon v-if="entry.experimental">mdi-test-tube</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group v-else :key="i" no-action :prepend-icon="entry.icon">
            <template #activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ entry.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(subEntry, j) in entry.submenu"
              :key="j"
              @click="pushRoute(subEntry)"
              :class="{
                'v-list-item--active': $route.name === subEntry.route.name,
              }"
            >
              <v-list-item-icon>
                <v-icon>{{ subEntry.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ subEntry.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  components: {
    DarkModeSwitch: () => import("@/components/DarkModeSwitch"),
    BellIcon: () => import("@/components/BellIcon"),
    FileUploadIcon: () => import("@/components/FileUploadIcon"),
    Logo: () => import("@/components/Logo"),
    ServerSelection: () => import("@/components/ServerSelection"),
  },
  data() {
    return {
      mini: true,
      drawer: null,
      menuEntries: [
        {
          title: "Benutzer & Rechte",
          icon: "mdi-account-key",
          route: { name: "users" },
        },
        {
          title: "Kanäle & Leute",
          icon: "mdi-file-tree",
          route: { name: "live" },
        },
        {
          title: "Rollen",
          icon: "mdi-shield-account",
          route: { name: "rollen" },
        },
        {
          title: "Einladungen",
          icon: "mdi-email-plus-outline",
          route: { name: "einladungen" },
        },
        {
          title: "Protokoll",
          icon: "mdi-history",
          route: { name: "protokoll" },
        },
        {
          title: "Server-Liste",
          icon: "dns",
          route: { name: "servers" },
        },
        {
          title: "Server-Ansicht (alt)",
          icon: "remove_red_eye",
          route: { name: "serverviewer" },
        },
        {
          title: "Chat",
          icon: "mail_outline",
          route: { name: "chat" },
        },
        {
          title: "Dateien",
          icon: "mdi-folder",
          route: { name: "files" },
        },
        {
          title: "Server-Log",
          icon: "mdi-file-document-outline",
          route: { name: "logs" },
        },
        {
          title: "Sicherung",
          icon: "settings_backup_restore",
          route: { name: "snapshot" },
        },
        {
          title: "Query-Konsole",
          icon: "mdi-console",
          route: { name: "console" },
        },
        {
          title: "Einladungsschlüssel (alt)",
          icon: "mdi-key",
          route: { name: "tokens" },
        },
        {
          title: "API-Schlüssel",
          icon: "mdi-shield-key",
          route: { name: "apikeys" },
        },
        {
          title: "Bann-Liste",
          icon: "not_interested",
          route: { name: "bans" },
        },
        {
          title: "Beschwerden",
          icon: "warning",
          route: { name: "complaints" },
        },

        {
          title: "Alle Benutzer (Tabelle)",
          icon: "person",
          route: { name: "clients" },
        },
        {
          title: "Server-Gruppen",
          icon: "group",
          route: { name: "servergroups" },
        },
        {
          title: "Kanal-Gruppen",
          icon: "mdi-hexagon-slice-4",
          route: { name: "channelgroups" },
        },
        {
          title: "Rechte (für Profis)",
          icon: "mdi-format-section",
          submenu: [
            {
              title: "Server-Gruppe",
              icon: "group",
              route: { name: "permissions-servergroup" },
            },
            {
              title: "Benutzer-Rechte",
              icon: "person",
              route: { name: "permissions-client" },
            },
            {
              title: "Kanal-Rechte",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channel" },
            },
            {
              title: "Kanal-Gruppen",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channelgroup" },
            },
            {
              title: "Kanal-Rechte je Benutzer",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channelclient" },
            },
          ],
        },
        {
          title: "Abmelden",
          icon: "exit_to_app",
          route: { name: "logout" },
        },
      ],
    };
  },
  computed: {
    connected() {
      return this.$store.state.query.connected;
    },
  },
  methods: {
    pushRoute(entry) {
      if (entry.route.name !== this.$route.name) {
        this.$router.push(entry.route);
      }
    },
  },
};
</script>
